module.exports = __webpack_public_path__ + "static/media/share-icon-black.5f0be2a6.svg";